import axios from "axios";

const abacusCoreApiBaseUrl =
  process.env.NODE_ENV === "production"
    ? "https://us-central1-abacuscorev2live.cloudfunctions.net/"
    : "https://us-central1-abacus-company-project.cloudfunctions.net/";
export const instance = axios.create({
  baseURL: abacusCoreApiBaseUrl,
  timeout: 60000,
  headers: {
    "content-type": "application/json",
    Authorization: "ApiKey 75kY0sSlOILOlfLE6hQbFu57f2VA1JirTEy79Thy"
  }
});
